import Google from './providers/google';
import Yandex from './providers/yandex';

export default { Google, Yandex };
